export default "__VITE_ASSET__BeNdheAc__"